"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  App: {
    header: {
      title: {
        text: "Franco",
        href: "/franco-exhumacion-entierro/",
        hrefTitle: ""
      },
      share: {
        text: "COMPARTIR",
        layout: "verticalLayout"
      }
    },
    footer: {
      text: "Contenido footer"
    }
  },
  Home: {
    carousel: [{
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "INICIO",
        text: "Franco <a href='http://www.rtve.es/rtve/20151119/espanoles-franco-muerto/192577.shtml' target='_blank' class='link'><span class='bold'>fallece el día 20 de noviembre de 1975</span></a>. Su cuerpo se vela en privado en el Palacio del Pardo. Al día siguiente se instala la <span class='bold'>capilla ardiente pública</span> en el Palacio de Oriente. Decenas de miles de ciudadanos pasan frente al féretro para despedirse del dictador. El <span class='bold'>23 de noviembre se celebra un funeral de cuerpo presente</span> en la Plaza de Oriente. Don Juan Carlos y Doña Sofía, además de otras personalidades, asisten al acto tras ser coronados Reyes de España.",
        anio: "left",
        video: {
          titleVideo: "INICIO 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          poster: '/media/image/video/Franco1A_Misa.jpg',
          duration: '116',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco1A_Misa_desk_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco1A_Misa_mob_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "INICIO",
        text: "Después de casi 44 años y <a href='http://www.rtve.es/noticias/20191024/claves-exhumacion-franco-valle-caidos/1980895.shtml' target='_blank' class='link'><span class='bold'>tras 16 meses de enfrentamiento legal</span></a> entre el Gobierno de Pedro Sánchez y la familia Franco, se <a href='http://www.rtve.es/noticias/20191023/franco-exhumado-del-valle-caidos-44-anos-despues/1985021.shtml' target='_blank' class='link'><span class='bold'>exhuma al dictador</span></a> del Valle de los Caídos. Dentro de la Basílica se levanta una carpa sobre la tumba para extraer al féretro. Solo están presentes durante esas <a href='http://www.rtve.es/noticias/20191024/claves-exhumacion-franco-valle-caidos/1980895.shtml' target='_blank' class='link'><span class='bold'>dos horas de trabajos</span></a> dos familiares, un forense, la ministra de Justicia en funciones, Dolores Delgado -como notaria mayor del Reino- y el personal indispensable para levantar la lápida.",
        anio: "right",
        video: {
          titleVideo: "INICIO 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '116',
          poster: '/media/image/video/Franco1B_Misa.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco1B_Misa_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco1B_Misa_mob_v6.mp4"
        }
      }]
    }, {
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "TRASLADO DEL CUERPO",
        text: "Tras el funeral público, <span class='bold'>el féretro es trasladado al Valle de los Caídos</span>, donde los restos mortales de Francisco Franco son inhumados en la basílica. Un <span class='bold'>cortejo fúnebre formado por 4.500 hombres</span> de la región Militar acompañaron al féretro desde Plaza de Oriente al Valle de los Caídos. El caudillo fue transportado en un coche militar adaptado para el cortejo fúnebre. Solo se autorizó a circular a los coches del Gobierno, representaciones extranjeras y altas personalidades.",
        anio: "left",
        video: {
          titleVideo: "TRASLADO DEL CUERPO 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '112',
          poster: '/media/image/video/Franco2A_Traslado.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco2A_Traslado_desk_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco2A_Traslado_mob_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "TRASLADO DEL CUERPO",
        text: "Tras la exhumación y un breve responso, los restos mortales de Franco son portados hasta el coche fúnebre <span class='bold'>a hombros por 8 de sus familiares</span>, con Cristóbal Martínez Bordiú y Luis Felipe de Borbón a la cabeza. Desde allí, se dirigen a un helicóptero de las Fuerzas Armadas que traslada los restos al <a href='http://www.rtve.es/noticias/20191024/asi-cementerio-mingorrubio/1985047.shtml' target='_blank' class='link'><span class='bold'>cementerio de Mingorrubio</span></a>. A bordo también vuelan Francis Franco, el nieto mayor del dictador, y la ministra de Justicia. El resto de la familia se traslada por carretera hasta el campo santo.",
        anio: "right",
        video: {
          titleVideo: "TRASLADO DEL CUERPO 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '112',
          poster: '/media/image/video/Franco2B_Traslado.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco2B_Traslado_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco2B_Traslado_mob_v6.mp4"
        }
      }]
    }, {
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "¿DÓNDE ES ENTERRADO?",
        text: "Los restos del dictador son <a href='http://www.rtve.es/alacarta/videos/telediario/historia-del-valle-caidos/4706124/' target='_blank' class='link'><span class='bold'>enterrados en la basílica del Valle de los Caídos</span></a>, ubicada en El Escorial. Franco ordenó <span class='bold'>construirla en 1940</span> y allí trabajaron cerca de 20.000 presos políticos. Fue inaugurado en 1959. En el Valle <span class='bold'>descansan</span> los restos de José Antonio Primo de Rivera y <span class='bold'>33.833 víctimas</span> de ambos bandos de la Guerra Civil; más de 12.000 sin identificar.",
        anio: "left",
        video: {
          titleVideo: "¿DÓNDE ES ENTERRADO? 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '63',
          poster: '/media/image/video/Franco3A_Mausoleo.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco3A_Mausoleo_desk_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco3A_Mausoleo_mob_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "¿DÓNDE ES ENTERRADO?",
        text: "Los restos de Franco son enterrados en un panteón propiedad de su familia, donde <span class='bold'>descansa desde 1988 Carmen Polo</span>, la esposa del dictador. Este campo santo, situado a 15 km de Madrid, es también el lugar donde fueron enterrados una decena de personalidades de la Dictadura, como Arias Navarro o Carrero Blanco",
        anio: "right",
        video: {
          titleVideo: "¿DÓNDE ES ENTERRADO? 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '63',
          poster: '/media/image/video/Franco3B_Mausoleo.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco3B_Mausoleo_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco3B_Mausoleo_mob_v6.mp4"
        }
      }]
    }, {
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "¿QUIÉNES ASISTEN AL ENTIERRO?",
        text: "A los actos funerarios acuden más de <span class='bold'>90 delegaciones extranjeras</span>. El rey Hussein de Jordania, el dictador chileno Augusto Pinochet, el príncipe Rainiero de Mónaco, el vicepresidente norteamericano Nelson Rockefeller y la primera dama de Filipinas Imelda Marcos son parte de los mandatarios que asisten. Cerca de <span class='bold'>200 periodistas, nacionales y extranjeros</span>, cubren las exequias del dictador.",
        anio: "left",
        video: {
          titleVideo: "¿QUIÉNES ASISTIERON AL ENTIERRO? 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '102',
          poster: '/media/image/video/Franco5A_Asistentes.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco5A_Asistentes_desk_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco5A_Asistentes_mob_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "¿QUIÉNES ASISTEN AL ENTIERRO?",
        text: "Hasta <span class='bold'>22 familiares, entre nietos, bisnietos y cónyuges</span>, de la Familia Franco han acompañado los restos mortales del dictador. Pese a que llegaron con la bandera preconstitucional al Valle, las fuerzas de seguridad les han impedido exhibirla allí. Al mismo tiempo, cientos de personas se agolpaban en Mingorrubio para recibir la comitiva fúnebre entre vítores y <a href='http://www.rtve.es/noticias/20191024/viva-franco-viva-espana-cientos-franquistas-se-concentran-ante-cementerio-pardo/1985121.shtml' target='_blank' class='link bold'>“vivas” a Franco e insultos al presidente del Gobierno</a>, Pedro Sánchez.",
        anio: "right",
        video: {
          titleVideo: "¿QUIÉNES ASISTIERON AL ENTIERRO? 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '102',
          poster: '/media/image/video/Franco5A_Asistentes.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco5B_Asistentes_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco5B_Asistentes_mob_v6.mp4"
        }
      }]
    }, {
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "¿CÓMO ES LA CEREMONIA?",
        text: "Entre cantos gregorianos y el himno nacional <a href='http://www.rtve.es/alacarta/videos/programas-y-concursos-en-el-archivo-de-rtve/imagenes-del-entierro-franco-1975/337452/' target='_blank' class='link'><span class='bold'>llega la procesión fúnebre al Valle de los Caídos</span></a>. La familia, junto al nuevo rey de España y al Gobierno, se sitúa bajo el altar mayor en primera fila. Antes de la inhumación <span class='bold'>se despoja al féretro de la bandera nacional, el sable, el bastón de mando y la gorra militar</span>. Una losa de mármol de <span class='bold'>1.500 kilos de peso</span> sella la tumba de Francisco Franco.",
        anio: "left",
        video: {
          titleVideo: "¿CÓMO ES LA CEREMONIA? 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '164',
          poster: '/media/image/video/Franco4A_Entierro.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco4A_Entierro_desk_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco4A_Entierro_mob_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "¿CÓMO ES LA CEREMONIA?",
        text: "Todo el acto se ha desarrollado en la intimidad, a puerta cerrada y con <span class='bold'>estrictas medidas de seguridad</span> para que no haya grabaciones. <span class='bold'>La ceremonia religiosa es oficiada por Ramón Tejero</span>, hijo del golpista Antonio Tejero <a href='http://www.rtve.es/alacarta/videos/los-desayunos-de-tve/tejero-llega-cementerio-del-prado-mingorrubio-entre-momentos-tension/5421750/' target='_blank' class='link'><span class='bold'>-que también ha acudido-</span></a>, y por el prior del Valle de los Caídos, Santiago Cantera. Durante este acto, dentro del panteón, el Gobierno sí permite la presencia de símbolos políticos y banderas. Al acabar la ceremonia, los Franco han atendido a la prensa <a href='http://www.rtve.es/noticias/20191024/franco-critican-grave-atropello-derechos-tras-exhumacion-su-abuelo/1985322.shtml' target='_blank' class='link'><span class='bold'>exhibiendo la bandera preconstitucional.</span></a>",
        anio: "right",
        video: {
          titleVideo: "¿CÓMO ES LA CEREMONIA? 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '164',
          poster: '/media/image/video/Franco4B_Entierro.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco4B_Entierro_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco4B_Entierro_mob_v6.mp4"
        }
      }]
    }, {
      videos: [{
        title: "23 noviembre 1975",
        subTitle: "¿CÓMO LO VIVE ESPAÑA?",
        text: "<span class='bold'>Tres días de luto nacional</span> fueron decretados tras la muerte del jefe del Estado. Las <span class='bold'>banderas de todos los edificios oficiales ondearon a media asta</span>. Las emisoras de radio, conectadas a Radio Nacional, transmiten continuamente música fúnebre entre los boletines informativos. En Madrid miles de personas hicieron cola para visitar la capilla ardiente. Hasta el Valle de los Caídos siguió la multitud el féretro y <span class='bold'>se estima que acudieron cerca de 100.000 personas</span>, que se debatían entre un silencioso respeto y bulliciosos cánticos.",
        anio: "left",
        video: {
          titleVideo: "¿CÓMO LO VIVIÓ ESPAÑA? 1975",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '119',
          poster: '/media/image/video/Franco6A_Espanha.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco6A_Espanha_mob_v3.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/1975/Franco6A_Espanha_desk_v3.mp4"
        }
      }, {
        title: "24 de OCTUBRE 2019",
        subTitle: "¿CÓMO LO VIVE ESPAÑA?",
        text: "Desde semanas antes, la noticia de la exhumación ha sido seguida por los medios nacionales. Hasta <span class='bold'>92 medios españoles y 58 internacionales</span>, procedentes de 17 países, se han acreditado para informar de esta jornada histórica. En la calle, reinaba la tranquilidad y en los edificios institucionales se desarrolla con normalidad la jornada laboral. Los únicos momentos de tensión se han vivido en Mingorrubio, donde se jaleaba al dictador.",
        anio: "right",
        video: {
          titleVideo: "¿CÓMO LO VIVIÓ ESPAÑA? 2019",
          subtitle: "¡MAKING OF A BORDO!",
          titleProject: "Franco exhumación entierro",
          duration: '119',
          poster: '/media/image/video/Franco6B_Espanha.jpg',
          videoSrc: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco6B_Espanha_desk_v6.mp4",
          videoSrcMobile: "http://video-lab.rtve.es/resources/TE_NGVA/proyectos/franco-exhumacion-entierro/2019/Franco6B_Espanha_mob_v6.mp4"
        }
      }]
    }],
    Credits: {
      verEspecial: {
        link: "http://www.rtve.es/v/5419018",
        text: 'Ver especial del entierro de Franco en el archivo de RTVE'
      },
      titleCreditos: 'Créditos',
      items: [{
        title: "Documentación",
        description: "SERVICIOS INFORMATIVOS RTVE"
      }, {
        title: "Guion",
        description: "Esther Peréz Amat"
      }, {
        title: "Realización",
        description: "Marcos Martin Gómez, <span class='br'>Pelayo Prieto Menéndez,</span> <span class='br'>Ana Martínez Jiménez</span>"
      }, {
        title: "Diseño",
        description: "Lab RTVE.es"
      }, {
        title: "Desarrollo",
        description: "Lab RTVE.es"
      }, {
        title: "Coordinación",
        description: "Miriam Hernanz"
      }]
    },
    Cover: {
      title: "Los 2 entierros <span>de</span> <span>Franco</span>",
      text: "El entierro de Franco en 1975 en el Valle de los Caídos marcó el fin de la Dictadura y el inicio de la Transición democrática. En 2019, por decisión del Gobierno y ratificado por el Supremo, se han exhumado sus restos para ser trasladados a un panteón en Mingorrubio. Analizamos las diferencias y similitudes entre los dos entierros de Franco.",
      textMobile: "El entierro de Franco en 1975 marcó el fin de la Dictadura y el inicio de la Transición. En 2019, sus restos han sido exhumados para ser trasladados a un panteón en Mingorrubio."
    },
    Instructions: {
      texts: [{
        date: "1975",
        text: "Franco murió un 20 de noviembre de 1975 y fue enterrado con honores de jefe de Estado en el Valle de los Caídos."
      }, {
        date: "2019",
        text: "Franco es exhumado el 24 de octubre de 2019 y enterrado en una ceremonia privada en el cementerio del Pardo."
      }],
      instructions: 'Haz scroll y cambia de vídeo para comparar'
    }
  }
};
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/redux/i18n/es.js
// module id = 295
// module chunks = 0